import { UnitSelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  unit_id: {
    'ui:widget': UnitSelectionWidget,
  },
});

export default uiSchema;
